export default __webpack_public_path__ + "static/media/ip-addressImg_1.c205dafc.webp";